<div class="genericCardDs__cont" [id]="'genericCardDs__Id-' + dsId" [class.adjusted-height]="adjustedHeight">
  @if (image?.IsEnabled) {
    <div class="genericCardDs__image">
      <div class="genericCardDs__image-src">
        <app-ds-image
          [size]="imageSize"
          [src]="image?.Src"
          [srcFallback]="image?.SrcFallback"
          [width]="'100%'"
          [height]="'180px'"
          [objectFit]="'cover'"
          [borderRadius]="'var(--border-radius-nano)'"
          [useLoader]="true">
        </app-ds-image>
      </div>
      @if (image?.DiscountLabel) {
        <div class="genericCardDs__image-tag">
          <app-ds-tag-member
            [label]="image?.DiscountLabel"
            [sliced]="null"
            [withoutTagBorder]="false">
          </app-ds-tag-member>
        </div>
      }
    </div>
  } @else if (header?.Selected?.IsEnabled || header?.Summary?.IsEnabled) {
    <div class="genericCardDs__header">
      @if (header.Selected?.IsEnabled) {
        <app-ds-header
          [type]="headerType"
          [widgetConfig]="[{ Type: headerWidgetType, Label: header.Selected.Title }]">
        </app-ds-header>
      }
      @if (header?.Summary?.IsEnabled) {
        <div
          class="genericCardDs__header--summary genericCardDs__header--summary--{{space}}"
          [class.enabled-header-selected]="header?.Selected?.IsEnabled">
          <div class="genericCardDs__header--summary-info-left">
            @if (header.Summary.Icon) {
              <div class="genericCardDs__header--summary-info-icon">
                <app-ds-icon
                  [icon]="header.Summary.Icon"
                  [size]="16">
                </app-ds-icon>
              </div>
            }
            <div class="genericCardDs__header--summary-info-text">
              @if (header.Summary.Title) {
                <app-ds-typography
                  [size]="fontSize.XXXS"
                  [color]="fontColor.Primary"
                  [fontFamily]="fontFamily.SemiBold"
                  [text]="header.Summary.Title">
                </app-ds-typography>
              }
              @if (header.Summary.Description) {
                <app-ds-typography
                  [size]="fontSize.XXXS"
                  [color]="fontColor.Primary"
                  [text]="': ' + header.Summary.Description">
                </app-ds-typography>
              }
            </div>
          </div>
          @if (header.Summary.Action) {
            <div class="genericCardDs__header--summary-info-right">
              <app-ds-button-link
                [type]="buttonLinkType.Secondary"
                [iconPosition]="buttonLinkIconPosition.Right"
                [fontSize]="fontSize.XXXS"
                [icon]="header.Summary.Action.Icon"
                [iconSize]="16"
                [label]="header.Summary.Action.Label"
                (clickEvent)="clickEventByHeaderAction.emit()">
              </app-ds-button-link>
            </div>
          }
        </div>
        <div class="genericCardDs__divider genericCardDs__divider--{{space}}">
          <app-ds-divider></app-ds-divider>
        </div>
      }
    </div>
  }
  <button
    class="genericCardDs__button genericCardDs__button--{{space}}"
    aria-label="genericCardDs--button"
    [class.highlight]="highlight"
    [class.enabled-image]="image?.IsEnabled"
    [class.enabled-header]="header?.Selected?.IsEnabled || header?.Summary?.IsEnabled"
    [class.enabled-header-summary]="header?.Summary?.IsEnabled"
    [class.enabled-footer]="footer?.IsEnabled"
    [class.adjusted-height]="adjustedHeight"
    (click)="clickEvent.emit()">
    <ng-content></ng-content>
  </button>
  @if (footer?.IsEnabled) {
    <div class="genericCardDs__divider genericCardDs__divider--{{space}}">
      <app-ds-divider></app-ds-divider>
    </div>
    <button class="genericCardDs__footer genericCardDs__footer--{{space}}" aria-label="genericCardDs--footer" (click)="clickEventByFooter.emit()">
      <div class="genericCardDs__footer--widget">
        @if (footer?.Icon) {
          <app-ds-icon
            [icon]="footer.Icon"
            [color]="iconFillColor.Primary"
            [size]="18">
          </app-ds-icon>
        }
        <div class="genericCardDs__footer--widget-text">
          <app-ds-typography
            [size]="fontSize.XXXS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.SemiBold"
            [text]="footer.Title">
          </app-ds-typography>
        </div>
      </div>
      <div class="genericCardDs__footer--action">
        @if (footer?.CustomAction?.Label && !footer?.IsLoading) {
          <app-ds-typography
            [size]="fontSize.XXXS"
            [color]="fontColor.Primary"
            [fontFamily]="fontFamily.SemiBold"
            [text]="footer.CustomAction.Label">
          </app-ds-typography>
        }
        <div class="genericCardDs__footer--action-icon">
          @if (footer?.IsLoading) {
            <app-ds-loader-ring
              [type]="'secondary'"
              [size]="'16px'">
            </app-ds-loader-ring>
          } @else {
            <app-ds-icon
              [icon]="footer?.CustomAction?.Icon ?? icons.ChevronRight"
              [color]="iconFillColor.Primary"
              [size]="16">
            </app-ds-icon>
          }
        </div>
      </div>
    </button>
  }
</div>
